const SVGObj = require("svg.js");
let SVGExport;

// if (process.env.NODE_ENV !== "test") {
  SVGExport = SVGObj;
// }

export const SVG = SVGExport;
